module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Sign-in-518b8150223fb64b8663db9323f3528a.svg";